module.exports = __webpack_public_path__ + "static/media/logo_bwki.ed0fe6be.png";